import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "./utils";

export const buttonVariants = cva(
  "tw-inline-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-md tw-border tw-border-transparent tw-font-sans tw-text-sm tw-font-medium tw-leading-5 tw-no-underline tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 [&_svg]:tw-size-4 [&_svg]:tw-shrink-0",
  {
    variants: {
      variant: {
        default: "tw-bg-primary tw-text-primary-foreground tw-shadow-sm hover:tw-bg-primary/90",
        destructive: "tw-bg-destructive tw-text-destructive-foreground tw-shadow-sm hover:tw-bg-destructive/90",
        outline: "tw-border-input tw-bg-background tw-text-foreground tw-shadow-sm hover:tw-bg-accent hover:tw-text-accent-foreground",
        secondary: "tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
        ghost: "tw-bg-transparent tw-text-foreground hover:tw-bg-accent hover:tw-text-accent-foreground",
        link: "tw-bg-transparent tw-text-primary hover:tw-underline",
      },
      size: {
        default: "tw-h-9 tw-px-4",
        sm: "tw-h-8 tw-px-3 tw-text-xs",
        lg: "tw-h-10 tw-px-6",
        icon: "tw-h-9 tw-w-9 tw-p-0",
        "icon-sm": "tw-h-8 tw-w-8 tw-p-0",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export const Button = React.forwardRef(({ className, variant, size, asChild = false, type, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      ref={ref}
      type={asChild ? undefined : type || "button"}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
});
Button.displayName = "Button";
